import lottie from 'lottie-web/build/player/lottie_light';
import { getSettings } from './svgAnimations';

let CONFIG = {};

let ANIMATIONS = [];

// アクティブなアニメーションを管理（リサイズ時のfooter被りチェック用）
const activeAnims = new Set();

function rand(min, max) {
  return Math.random() * (max - min) + min;
}

function randInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function getThemeURL() {
  if (typeof themeURL !== 'undefined') return themeURL;
  const link = document.querySelector('link[href*="/dist/assets/css/site.css"]');
  if (link) {
    return link.href.replace(/\/dist\/assets\/css\/site\.css.*$/, '');
  }
  return '';
}

const DIRECTION_ANGLES = {
  'up':         [270, 270],
  'down':       [90, 90],
  'right':      [0, 0],
  'left':       [180, 180],
  'up-right':   [285, 345],
  'up-left':    [195, 255],
  'down-right': [15, 75],
  'down-left':  [105, 165],
};

function getAngleRad(direction) {
  const range = DIRECTION_ANGLES[direction];
  if (!range) return null;
  const deg = rand(range[0], range[1]);
  return deg * Math.PI / 180;
}

function randomHSL(lightness) {
  const h = randInt(0, 360);
  const s = randInt(60, 100);
  const l = randInt(lightness.min, lightness.max);
  return `hsl(${h}, ${s}%, ${l}%)`;
}

function applyRandomColor(container, color) {
  const paths = container.querySelectorAll('path, circle, ellipse, rect, line, polyline, polygon');
  paths.forEach(el => {
    if (el.getAttribute('stroke') && el.getAttribute('stroke') !== 'none') {
      el.setAttribute('stroke', color);
    }
  });
}

function pickGroup(groups) {
  const total = groups.reduce((sum, g) => sum + g.weight, 0);
  let r = Math.random() * total;
  for (const group of groups) {
    r -= group.weight;
    if (r <= 0) return group;
  }
  return groups[groups.length - 1];
}

function getScale() {
  const ratio = Math.min(window.innerWidth / CONFIG.baseWidth, 1);
  // 非線形スケーリング: scaleMin を下限として、scaleCurve でカーブの強さを調整
  return CONFIG.scaleMin + (1 - CONFIG.scaleMin) * Math.pow(ratio, CONFIG.scaleCurve);
}

function spawnAnimation(parent) {
  const scale = getScale();
  const size = randInt(Math.round(CONFIG.size.min * scale), Math.round(CONFIG.size.max * scale));
  const vw = window.innerWidth;
  const vh = window.innerHeight;
  const group = pickGroup(ANIMATIONS);
  const animDef = group.items[randInt(0, group.items.length - 1)];
  const base = getThemeURL();
  const direction = animDef.direction || 'none';
  const isMoving = direction !== 'none';

  // 速度決定
  const speedRange = animDef.speed || CONFIG.speed;
  const speed = isMoving ? rand(speedRange.min, speedRange.max) : 0;

  // 角度決定
  const angle = isMoving ? getAngleRad(direction) : null;
  const vx = angle !== null ? speed * Math.cos(angle) : 0;
  const vy = angle !== null ? speed * Math.sin(angle) : 0;

  // 共有状態オブジェクト（tick と handleResize の両方からアクセス）
  const state = { x: 0, y: 0, size };

  // 初期位置（viewport相対）
  if (isMoving) {
    state.x = vx > 0 ? rand(0, Math.max(0, (vw - size) * 0.4))
      : vx < 0 ? rand((vw - size) * 0.6, Math.max(0, vw - size))
      : rand(0, Math.max(0, vw - size));
    state.y = vy > 0 ? rand(0, Math.max(0, (vh - size) * 0.4))
      : vy < 0 ? rand((vh - size) * 0.6, Math.max(0, vh - size))
      : rand(0, Math.max(0, vh - size));
  } else {
    state.x = rand(0, Math.max(0, vw - size));
    state.y = rand(0, Math.max(0, vh - size));
  }

  // bodyモード: viewport座標 → ページ上の絶対座標に変換
  if (CONFIG.mode === 'body') {
    state.x += window.scrollX;
    state.y += window.scrollY;

    // footerより下にスポーンしないように制限
    const footer = document.querySelector('footer');
    if (footer) {
      const footerPageTop = footer.getBoundingClientRect().top + window.scrollY;
      if (state.y + size > footerPageTop) {
        state.y = Math.max(0, footerPageTop - size);
      }
    }
  }

  // リサイズ対応: スポーン時のビューポートサイズを記録
  const spawnVw = vw;
  const spawnVh = vh;

  const zIndex = CONFIG.mode === 'body' ? 31 : 9999;
  const container = document.createElement('div');
  container.style.cssText = `position:absolute;left:${state.x}px;top:${state.y}px;width:${size}px;height:${size}px;pointer-events:none;opacity:0;transition:opacity ${CONFIG.fade.in}ms ease;z-index:${zIndex};`;
  parent.appendChild(container);
  // 初期状態をレンダリングさせてからopacityを変更してトランジションを発火
  requestAnimationFrame(() => {
    requestAnimationFrame(() => { container.style.opacity = '1'; });
  });

  const anim = lottie.loadAnimation({
    container: container,
    renderer: 'svg',
    loop: true,
    autoplay: true,
    path: `${base}/dist/assets/${animDef.path}`,
  });

  if (animDef.randomColor) {
    const lightness = animDef.lightness || { min: 40, max: 70 };
    const color = randomHSL(lightness);
    anim.addEventListener('DOMLoaded', () => {
      applyRandomColor(container, color);
    });
  }

  const duration = randInt(CONFIG.duration.min, CONFIG.duration.max);
  const startTime = performance.now();
  let rafId = null;
  let removed = false;
  const footer = document.querySelector('footer');
  // footer手前のどの距離から減衰を始めるか
  const dampingZone = 200;

  function removeAnim() {
    if (removed) return;
    removed = true;
    activeAnims.delete(entry);
    container.style.transition = `opacity ${CONFIG.fade.out}ms ease`;
    container.style.opacity = '0';
    setTimeout(() => {
      if (rafId !== null) cancelAnimationFrame(rafId);
      anim.destroy();
      container.remove();
    }, CONFIG.fade.out);
  }

  const entry = {
    container, get size() { return state.size; }, removeAnim, isRemoved: () => removed,
    // リサイズ時にサイズ・位置を再計算
    handleResize() {
      if (removed) return;
      const newVw = window.innerWidth;
      const newVh = window.innerHeight;
      const ratio = newVw / spawnVw;
      const newSize = Math.round(state.size * ratio);
      // 位置をビューポート比率で調整し、はみ出し防止
      const maxX = CONFIG.mode === 'body' ? Infinity : Math.max(0, newVw - newSize);
      const maxY = CONFIG.mode === 'body' ? Infinity : Math.max(0, newVh - newSize);
      state.x = Math.min(Math.max(0, state.x * ratio), maxX);
      state.y = Math.min(Math.max(0, state.y * (newVh / spawnVh)), maxY);
      state.size = newSize;
      container.style.width = newSize + 'px';
      container.style.height = newSize + 'px';
      container.style.left = state.x + 'px';
      container.style.top = state.y + 'px';
    },
  };

  if (isMoving) {
    let lastTime = startTime;
    let currentVy = vy;
    const tick = (now) => {
      const dt = (now - lastTime) / 1000;
      lastTime = now;

      // footerとの距離に応じてvy（下方向）を減衰
      if (footer && vy > 0) {
        const footerTop = footer.getBoundingClientRect().top;
        const viewY = CONFIG.mode === 'body' ? state.y - window.scrollY : state.y;
        const dist = footerTop - (viewY + state.size);

        if (dist <= 0) {
          // footerに到達 → 静止
          currentVy = 0;
        } else {
          // 減衰ゾーン内: 距離に比例してvyを0に近づける
          const ratio = Math.min(dist / dampingZone, 1);
          currentVy = vy * ratio;
        }
      }

      state.x += vx * dt;
      state.y += currentVy * dt;
      container.style.left = state.x + 'px';
      container.style.top = state.y + 'px';
      if (now - startTime < duration) {
        rafId = requestAnimationFrame(tick);
      }
    };
    rafId = requestAnimationFrame(tick);
  }

  activeAnims.add(entry);

  // 寿命によるフェードアウト
  setTimeout(() => {
    removeAnim();
  }, duration - CONFIG.fade.out);
}

function scheduleNext(parent) {
  const delay = randInt(CONFIG.interval.min, CONFIG.interval.max);
  setTimeout(() => {
    spawnAnimation(parent);
    scheduleNext(parent);
  }, delay);
}

export function svgAnimOverlay() {
  const settings = getSettings();
  if (!settings) return;
  CONFIG = settings.config;
  ANIMATIONS = settings.animations;
  let parent;
  if (CONFIG.mode === 'overlay') {
    parent = document.createElement('div');
    parent.style.cssText = 'position:fixed;top:0;left:0;right:0;bottom:0;pointer-events:none;z-index:9999;overflow:hidden;';
    document.body.appendChild(parent);

    // footerがviewport内に見えている分だけoverlayの下端を縮める
    const footer = document.querySelector('footer');
    if (footer) {
      const updateBottom = () => {
        const footerTop = footer.getBoundingClientRect().top;
        const vh = window.innerHeight;
        const overlap = Math.max(0, vh - footerTop);
        parent.style.bottom = overlap + 'px';
      };
      updateBottom();
      window.addEventListener('resize', updateBottom);
      window.addEventListener('scroll', updateBottom);
    }

    // overlayコンテナ下部にグラデーションを追加
    const gradientEl = document.createElement('div');
    const bgColor = getComputedStyle(document.documentElement).getPropertyValue('--bgcolor').trim() || '#ffffff';
    gradientEl.style.cssText = `position:absolute;bottom:0;left:0;right:0;height:8rem;background:linear-gradient(to top,${bgColor},transparent);pointer-events:none;z-index:10000;`;
    parent.appendChild(gradientEl);
  } else {
    parent = document.createElement('div');
    parent.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:31;overflow:hidden;';
    document.body.appendChild(parent);
    // コンテナの高さをページ全体に合わせる
    const syncHeight = () => {
      parent.style.height = document.documentElement.scrollHeight + 'px';
    };
    syncHeight();
    window.addEventListener('resize', syncHeight);
    // DOM変更による高さ変化にも追従
    new ResizeObserver(syncHeight).observe(document.documentElement);
  }
  // リサイズ時: アニメーションコンテナのサイズ・位置を再計算し、footer被りをチェック
  const footerEl = document.querySelector('footer');
  window.addEventListener('resize', () => {
    for (const entry of activeAnims) {
      if (entry.isRemoved()) continue;
      entry.handleResize();
    }
    // footer被りチェック
    if (footerEl) {
      const footerTop = footerEl.getBoundingClientRect().top;
      for (const entry of activeAnims) {
        if (entry.isRemoved()) continue;
        const rect = entry.container.getBoundingClientRect();
        if (rect.top + entry.size > footerTop) {
          entry.removeAnim();
        }
      }
    }
  });

  spawnAnimation(parent);
  scheduleNext(parent);
}
